import { usePreviewData } from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
export default function useError() {
  const {
    error
  } = usePreviewData();
  return error;
}